import { render, staticRenderFns } from "./PersonDistinct.vue?vue&type=template&id=4c0e99ba&"
import script from "./PersonDistinct.vue?vue&type=script&lang=js&"
export * from "./PersonDistinct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports